<script setup>
import { ref, watch, computed } from 'vue';
import Header from '../shared/header.vue';
import { Document, Setting as SettingIcon, UserFilled } from '@element-plus/icons-vue';
import SettingsContent from './settings-content.vue';
import RoleManager from './role-manager.vue';
import Gsheet from './gsheet.vue';
import McpServer from './mcp-server.vue';
import { useFVStore } from '../../stores/formvibes';
import { storeToRefs } from 'pinia';


const activeName = ref( window.location.hash.replace("#", "") || 'settings');

const store = useFVStore();
const { notice,isPro, settings } = storeToRefs(store);

const handleTabChange = (tab, event) => {
    window.location.hash = tab;
};

const isMcpEnabled = computed(() => {
    return settings.value?.enable_mcp_server === true;
});

watch([notice], () => {
    ElNotification({
        offset: 30,
        dangerouslyUseHTMLString: true,
        message: `<strong>${notice.value.message}</strong>`,
        type: notice.value.isError ? 'error' : 'success',
        class:'fv-items-center'
    })
})

</script>
<template>
    <div>
        <Header />
        <div class="fv-settings-wrapper fv-pr-5">
            <el-tabs
                v-model="activeName"
                type="card"
                class="fv-settings-tab"
                @tab-change="handleTabChange"
            >
                <el-tab-pane name="settings">
                    <template #label>
                        <el-icon><SettingIcon /></el-icon>
                        Settings
                    </template>
                    <SettingsContent />
                </el-tab-pane>
                <el-tab-pane name="rolemanager" v-if="isPro">
                    <template #label>
                        <el-icon><UserFilled /></el-icon>
                        Role Manager
                    </template>
                    <RoleManager />
                </el-tab-pane>
                <el-tab-pane name="gsheet" v-if="isPro">
                    <template #label>
                        <el-icon><Document /></el-icon>
                        Google Sheet
                    </template>
                    <Gsheet />
                </el-tab-pane>
                <el-tab-pane name="mcpserver" v-if="isMcpEnabled && isPro">
                    <template #label>
                        <el-icon><Connection /></el-icon>
                        MCP Server Config (Beta)
                    </template>
                    <McpServer />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>